export var OperationType;
(function (OperationType) {
    OperationType["ALL"] = "ALL";
    OperationType["PERMISSION"] = "PERMISSION";
    OperationType["FILE"] = "FILE";
    OperationType["SETTING"] = "SETTING";
})(OperationType || (OperationType = {}));
export var OperationKeys;
(function (OperationKeys) {
    OperationKeys["UPDATE_SPACE_FIELD_SETTING"] = "UPDATE_SPACE_FIELD_SETTING";
    OperationKeys["QUIT_SHARE_FROM_SPACE"] = "QUIT_SHARE_FROM_SPACE";
    OperationKeys["OPEN_FOLDER_FAMILY_EXPANSION"] = "OPEN_FOLDER_FAMILY_EXPANSION";
    OperationKeys["CLOSE_FOLDER_FAMILY_EXPANSION"] = "CLOSE_FOLDER_FAMILY_EXPANSION";
    OperationKeys["OPEN_FOLDER_AUTO_COLLECTION"] = "OPEN_FOLDER_AUTO_COLLECTION";
    OperationKeys["CLOSE_FOLDER_AUTO_COLLECTION"] = "CLOSE_FOLDER_AUTO_COLLECTION";
    OperationKeys["OPEN_FOLDER_FAMILY_LABEL"] = "OPEN_FOLDER_FAMILY_LABEL";
    OperationKeys["CLOSE_FOLDER_FAMILY_LABEL"] = "CLOSE_FOLDER_FAMILY_LABEL";
    OperationKeys["COPY_FOLDER_IN_SAME_SPACE"] = "COPY_FOLDER_IN_SAME_SPACE";
    OperationKeys["COPY_FOLDER_FROM_OTHER_SPACE"] = "COPY_FOLDER_FROM_OTHER_SPACE";
    OperationKeys["RESTORE_FOLDER_FROM_RECYCLE_BIN"] = "RESTORE_FOLDER_FROM_RECYCLE_BIN";
    OperationKeys["QUIT_SHARE_FROM_FOLDER"] = "QUIT_SHARE_FROM_FOLDER";
    OperationKeys["ADD_SPACE_GROUP_SHARE"] = "ADD_SPACE_GROUP_SHARE";
    OperationKeys["DELETE_SPACE_GROUP_SHARE"] = "DELETE_SPACE_GROUP_SHARE";
    OperationKeys["ADD_FOLDER_GROUP_SHARE"] = "ADD_FOLDER_GROUP_SHARE";
    OperationKeys["DELETE_FOLDER_GROUP_SHARE"] = "DELETE_FOLDER_GROUP_SHARE";
    OperationKeys["MOVE_PATENT_IN_SAME_SPACE"] = "MOVE_PATENT_IN_SAME_SPACE";
    OperationKeys["COPY_PATENT_IN_SAME_SPACE"] = "COPY_PATENT_IN_SAME_SPACE";
    OperationKeys["CREATE_FOLDER_COMMENT"] = "CREATE_FOLDER_COMMENT";
    OperationKeys["UPDATE_FOLDER_COMMENT"] = "UPDATE_FOLDER_COMMENT";
    OperationKeys["DELETE_FOLDER_COMMENT"] = "DELETE_FOLDER_COMMENT";
    OperationKeys["ADD_NEW_PATENT"] = "ADD_NEW_PATENT";
    OperationKeys["IMPORT_NEW_PATENT"] = "IMPORT_NEW_PATENT";
    OperationKeys["MANUAL_COLLECT_PATENT"] = "MANUAL_COLLECT_PATENT";
    OperationKeys["AUTO_COLLECT_PATENT"] = "AUTO_COLLECT_PATENT";
    OperationKeys["AUTO_EXPANSION_PATENTS"] = "AUTO_EXPANSION_PATENTS";
    OperationKeys["MANUAL_EXPANSION_PATENTS"] = "MANUAL_EXPANSION_PATENTS";
    OperationKeys["MOVE_PATENT_FROM_OTHER_SPACE"] = "MOVE_PATENT_FROM_OTHER_SPACE";
    OperationKeys["COPY_PATENT_FROM_OTHER_SPACE"] = "COPY_PATENT_FROM_OTHER_SPACE";
    OperationKeys["RESTORE_PATENT_FROM_RECYCLE_BIN"] = "RESTORE_PATENT_FROM_RECYCLE_BIN";
    OperationKeys["DELETE_PATENT"] = "DELETE_PATENT";
    OperationKeys["MOVE_PATENT_TO_OTHER_SPACE"] = "MOVE_PATENT_TO_OTHER_SPACE";
    OperationKeys["ADD_FOLDER_USER_SHARE"] = "ADD_FOLDER_USER_SHARE";
    OperationKeys["DELETE_FOLDER_USER_SHARE"] = "DELETE_FOLDER_USER_SHARE";
    OperationKeys["UPDATE_SPACE_USER_SHARE"] = "UPDATE_SPACE_USER_SHARE";
    OperationKeys["UPDATE_FOLDER_USER_SHARE"] = "UPDATE_FOLDER_USER_SHARE";
    OperationKeys["UPDATE_FOLDER_GROUP_SHARE"] = "UPDATE_FOLDER_GROUP_SHARE";
    OperationKeys["UPDATE_SPACE_GROUP_SHARE"] = "UPDATE_SPACE_GROUP_SHARE";
    OperationKeys["ADD_SPACE_USER_SHARE"] = "ADD_SPACE_USER_SHARE";
    OperationKeys["DELETE_SPACE_USER_SHARE"] = "DELETE_SPACE_USER_SHARE";
    OperationKeys["ADD_COMPANY_SPACE_ADMIN"] = "ADD_COMPANY_SPACE_ADMIN";
    OperationKeys["DELETE_COMPANY_SPACE_ADMIN"] = "DELETE_COMPANY_SPACE_ADMIN";
    OperationKeys["DELETE_FOLDER"] = "DELETE_FOLDER";
    OperationKeys["MOVE_FOLDER_FROM_OTHER_SPACE"] = "MOVE_FOLDER_FROM_OTHER_SPACE";
    OperationKeys["MOVE_FOLDER_TO_OTHER_SPACE"] = "MOVE_FOLDER_TO_OTHER_SPACE";
    OperationKeys["AUTO_COLLECT_PATENT_BY_QUERY"] = "AUTO_COLLECT_PATENT_BY_QUERY";
    OperationKeys["MANUAL_COLLECT_PATENT_BY_QUERY"] = "MANUAL_COLLECT_PATENT_BY_QUERY";
    OperationKeys["ADD_NEW_PATENT_BY_QUERY"] = "ADD_NEW_PATENT_BY_QUERY";
})(OperationKeys || (OperationKeys = {}));
export var OperationSpecialQueryType;
(function (OperationSpecialQueryType) {
    OperationSpecialQueryType["BULK"] = "BULK";
    OperationSpecialQueryType["SEMANTIC"] = "SEMANTIC";
    OperationSpecialQueryType["NORMAL"] = "NORMAL";
})(OperationSpecialQueryType || (OperationSpecialQueryType = {}));
